// broadcast events originating from socket signals
import { Subject } from "rxjs"
import { SocketEvent } from "data/interface/socket"

// private module logic //

const socketStream = new Subject<SocketEvent>()

function newEvent(event: SocketEvent): void {
  socketStream.next(event)
}

// public module interface //

// globalChannel events
export const APPVERSION: string = "APPVERSION"

// propertyChannel events
export const CALC_STARTED: string = "CALC_STARTED_EVENT"
export const CALC_FINISHED: string = "CALC_FINISHED_EVENT"
export const CALC_ERROR: string = "CALC_ERROR_EVENT"
export const CALC_STATUS: string = "CALC_STATUS_EVENT"
export const PROPCHANNEL_CALC_PROPERTY_SYNC: string = "PROPCHANNEL_CALC_PROPERTY_SYNC_EVENT"
export const PROPERTY_SELECTED: string = "PROPERTY_SELECTED"
export const PROPERTY_UPDATED: string = "PROPERTY_UPDATED_EVENT"
export const RENTROLL_SUMMARY_COMPLETE: string = "RENTROLL_SUMMARY_COMPLETE"
export const RENTROLL_REORDER_COMPLETE: string = "RENTROLL_REORDER_COMPLETE"
export const PROPERTY_VALIDATION_COMPLETE: string = "PROPERTY_VALIDATION_COMPLETE"
export const PDF_IMPORT_STARTED: string = "PDF_IMPORT_STARTED"
export const PDF_IMPORT_ERROR: string = "PDF_IMPORT_ERROR"
export const PDF_IMPORT_FINISHED: string = "PDF_IMPORT_FINISHED"

// userChannel events
export const FOLDER_COPY_FINISHED: string = "FOLDER_COPY_FINISHED"
export const FOLDER_COPY_ERROR: string = "FOLDER_COPY_ERROR"
export const FOLDER_COPY_WARNING: string = "FOLDER_COPY_WARNING"
export const FOLDER_COPY_UPDATE: string = "FOLDER_COPY_UPDATE"
export const PROPERTY_COPY_FINISHED_EVENT: string = "PROPERTY_COPY_FINISHED_EVENT"
export const PROPERTY_COPY_ERROR_EVENT: string = "PROPERTY_COPY_ERROR_EVENT"
export const PROPERTY_COPY_UPDATE_EVENT: string = "PROPERTY_COPY_UPDATE_EVENT"
export const PROPERTY_MOVE_FINISHED_EVENT: string = "PROPERTY_MOVE_FINISHED_EVENT"
export const PROPERTY_MOVE_ERROR_EVENT: string = "PROPERTY_MOVE_ERROR_EVENT"
export const FOLDER_CALC_STARTED_EVENT: string = "FOLDER_CALC_STARTED_EVENT"
export const FOLDER_CALC_ERROR_EVENT: string = "FOLDER_CALC_ERROR_EVENT"
export const FOLDER_CALC_FINISHED_EVENT: string = "FOLDER_CALC_FINISHED_EVENT"
export const PROPERTY_CALC_IN_PROGRESS: string = "PROPERTY_CALC_IN_PROGRESS"
export const PROPERTY_CALC_FINISHED: string = "PROPERTY_CALC_FINISHED"
export const LOGOUT_DUP_CLIENTS: string = "LOGOUT_DUP_CLIENTS"
export const DATA_EXPORT_READY: string = "DATA_EXPORT_READY"
export const USERCHANNEL_CALC_PROPERTY_SYNC: string = "USERCHANNEL_CALC_PROPERTY_SYNC"
export const SNAPSHOT_RESTORE_UPDATE: string = "SNAPSHOT_RESTORE_UPDATE"
export const SNAPSHOT_RESTORE_COMPLETE: string = "SNAPSHOT_RESTORE_COMPLETE"
export const PROPERTY_RESTORE_COMPLETE: string = "PROPERTY_RESTORE_COMPLETE"
export const SNAPSHOT_CREATE_UPDATE: string = "SNAPSHOT_CREATE_UPDATE"
export const SNAPSHOT_CREATE_COMPLETE: string = "SNAPSHOT_CREATE_COMPLETE"
export const IMPORT_PROGRESS: string = "IMPORT_PROGRESS"
export const IMPORT_ERROR: string = "IMPORT_ERROR"
export const IMPORT_COMPLETE: string = "IMPORT_COMPLETE"
export const CREATE_SAMPLE_PROPERTIES: string = "CREATE_SAMPLE_PROPERTIES"
export const SAMPLE_PROPERTIES_FINISHED: string = "SAMPLE_PROPERTIES_FINISHED"
export const SAMPLE_PROPERTIES_ERROR: string = "SAMPLE_PROPERTIES_ERROR"
export const UNDERWRITING_WORKBOOK_COMPLETED: string = "UNDERWRITING_WORKBOOK_COMPLETED"
export const UNDERWRITING_WORKBOOK_ERROR: string = "UNDERWRITING_WORKBOOK_ERROR"

// folderChannel events
export const FOLDER_UPDATED: string = "FOLDER_UPDATED_EVENT"

// misc events
export const PROPERTY_CREATED_FROM_TEMPLATE: string = "PROPERTY_CREATED_FROM_TEMPLATE"

// service interface
const socketService = {
  stream: () => socketStream.asObservable(),
  newEvent: (event: SocketEvent) => newEvent(event)
}

export default socketService
